import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { FormikErrors } from 'formik'

import { HelperWrapper } from 'src/components'
import { COORDS_MULTIPLIER, MAP_SLIDER_MIN } from 'src/constants'
import { LocationItem } from './location-item'
import { CollapseItem } from './collapse-item'
import { AddLocationBtn } from './add-location-btn.component'

import { ILocationItem } from 'src/types/locations.type'
import { IStepForm } from 'src/types'
import useStyles from './styles'
import { useItemsRemoveConfirm } from 'src/hooks'

interface Props {
  isDisabled?: boolean
  errors: FormikErrors<IStepForm>
  locations: ILocationItem[]
  setFieldValue: (field: string, value: any) => void
}

const Locations = ({ errors, isDisabled, locations, setFieldValue }: Props) => {
  const [t] = useTranslation()
  const classes = useStyles()

  const { setRemoveConfirm } = useItemsRemoveConfirm()

  const shouldDisableAddLocationBtn = locations.some((location) => location.location_name === '')

  const handleAddLocation = () => {
    setFieldValue('locations', [
      ...locations,
      {
        location_name: '',
        location_address: '',
        latitude: 0,
        longitude: 0,
        radius: MAP_SLIDER_MIN,
      },
    ])
  }

  const deleteHandler = (index: number) => {
    const updatedLocations = locations.filter((_, i) => i !== index)
    setFieldValue('locations', updatedLocations)
  }

  const handleDeleteItem = () => async (index: number) => {
    setRemoveConfirm({
      handleConfirm: async () => {
        deleteHandler(index)
      },
      itemsTitles: [],
      itemsRelations: [],
      itemsType: t('confirm-modal-location-item.v'),
    })
  }

  return (
    <div className={classes.container}>
      {locations.length > 1 && (
        <Typography className={classes.inputType}>
          <HelperWrapper
            t="steps-locations-title"
            isColorInherited
            verticalPosition={10}
            size={10}
          />
        </Typography>
      )}
      {locations.map((location, index) => {
        if (locations.length === 1) {
          return (
            <LocationItem
              key={index}
              index={index}
              errors={
                (errors.locations ? errors.locations[index] : {}) as FormikErrors<ILocationItem>
              }
              isDisabled={isDisabled}
              location_address={location.location_address}
              location_name={location.location_name}
              radius={location.radius}
              centerProp={{
                lat: location.latitude ? location.latitude / COORDS_MULTIPLIER : 0,
                lng: location.longitude ? location.longitude / COORDS_MULTIPLIER : 0,
              }}
            />
          )
        }

        return (
          <>
            <CollapseItem
              index={index}
              name={location.location_name || location.location_address}
              deleteHandler={handleDeleteItem()}
              location={location}
            >
              <LocationItem
                key={index}
                index={index}
                errors={
                  (errors.locations ? errors.locations[index] : {}) as FormikErrors<ILocationItem>
                }
                isDisabled={isDisabled}
                location_address={location.location_address}
                location_name={location.location_name}
                radius={location.radius}
                centerProp={{
                  lat: location.latitude ? location.latitude / COORDS_MULTIPLIER : 0,
                  lng: location.longitude ? location.longitude / COORDS_MULTIPLIER : 0,
                }}
              />
            </CollapseItem>
          </>
        )
      })}

      <Box sx={{ pt: '25px' }}>
        <AddLocationBtn isDisabled={shouldDisableAddLocationBtn} handleClick={handleAddLocation} />
      </Box>
    </div>
  )
}

export { Locations }
